import React, { useEffect } from 'react';
import './App.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import { fetchCsrfToken } from './services/api';
import PrivateRoute from './components/common/PrivateRoute/PrivateRoute';
import Home from './pages/Home/Home';
import Blog from './pages/Catalog/Blog/Blog';
import Lookbooks from './pages/Catalog/Lookbook/Lookbooks';
import Contact from './pages/Info/Contact/Contact';
import About from './pages/Info/About/About';
import Collection from './pages/Catalog/Collection/Collection';
import CollectionAnnouncement from './pages/Catalog/Collection/CollectionAnnouncement';
import Admin from './pages/Admin/Admin';
import LegalMention from './pages/Info/LegalMention/LegalMention';
import NotFound from './pages/NotFound/NotFound';
import Login from './pages/Auth/Login/Login';

function App() {
  // CSRF PROTECTION: Fetch anti-forgery token on app initialization
  // Token is stored in memory and automatically included in all POST/PUT/DELETE requests
  // This prevents Cross-Site Request Forgery attacks
  useEffect(() => {
    fetchCsrfToken();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <div className="App-container">
          <div className="page-container">
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/lookbooks" element={<Lookbooks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/creations" element={<Collection />} />
            <Route path="/creations-announcement" element={<CollectionAnnouncement />} />

            <Route 
              path="/Admin" 
              element={
                <PrivateRoute adminOnly>
                  <Admin />
                </PrivateRoute>
              } 
            />

            <Route path="/legal-mention" element={<LegalMention />} />
            <Route path="/login" element={<Login />} />
            {/* Catch-all route for 404 Not Found */}
            <Route path="*" element={<NotFound />} />
            
            </Routes>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
